import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PalletsStackIcon } from 'assets';
import {
   NoItemsNotificationWithLink,
   SectionContainer,
   SharedGridTable,
   SharedGridTableCell,
   SharedGridTableRow,
} from 'components/shared';
import { ClientUserDTO, CommercialNetworkDetailsDTO, DistributionCenterDTO } from 'interfaces';

import style from './ClientDetailsRetailChains.module.css';
interface ClientDetailsRetailChainsProps {
   client: ClientUserDTO;
   commercialNetworksForClient: CommercialNetworkDetailsDTO[];
}

export const ClientDetailsRetailChains = (client: ClientDetailsRetailChainsProps) => {
   const { t } = useTranslation();
   const headers = useMemo(
      () => [t('commercial_network.table.name'), t('commercial_network.table.address')],
      [t],
   );

   const content = client.commercialNetworksForClient.length ? (
      client.commercialNetworksForClient.map((element: CommercialNetworkDetailsDTO) => {
         return (
            <SharedGridTableRow key={element.id} className={style.tableRow}>
               <SharedGridTableCell className={style.tableCellName}>
                  <h3>{element.name}</h3>
               </SharedGridTableCell>
               <SharedGridTableCell>
                  {element.addresses.map((item: DistributionCenterDTO) => (
                     <SharedGridTableCell className={style.tableCellInformation} key={item.id}>
                        {`${item.address.street}, ${item.address.zipCode} ${item.address.city}`}
                     </SharedGridTableCell>
                  ))}
               </SharedGridTableCell>
            </SharedGridTableRow>
         );
      })
   ) : (
      <NoItemsNotificationWithLink
         icon={<PalletsStackIcon />}
         desctiption={t('clientDetailsRetailChains.noItems')}
      />
   );

   return (
      <SectionContainer style={{ marginTop: 24 }} title={t('clientDetails.tabs.retailChains')}>
         <SharedGridTable
            style={{ paddingLeft: '12px' }}
            className={{
               headerRow: style.tableInnerContainer,
               headerCell: style.tableHeader,
            }}
            headers={headers}
            rows={content}
         />
      </SectionContainer>
   );
};
